import useUserDetails from "hooks/useUserDetails";
import { handleFetchAllBanks, handleVerifyAccount } from "api/fetchers";
import React from "react";
import { Modal } from "react-bootstrap";
import { useQuery } from "react-query";
import Select from "react-select";
import { SearchInput as InputField } from "component/TableSearchInput";
import { FeaturedIcon2 } from "asset/icons";
import { Button } from "../ui/Button";
import { GenericBtn } from "pages/finance/v2/FinanceRequest";
import { ChevronLeft } from "lucide-react";
import Input from "../form/Input";

const AddPoPaymentInfoModal = ({
    show,
    onClose,
    selectedSupplier,
    selectedBank,
    setSelectedBank,
    accountName,
    setAccountName,
    accountNumber,
    setAccountNumber,
    setSelectedSupplier,
    onSubmit,
    isLoading,
}) => {
    const { currency } = useUserDetails();
    const { data: bankList } = useQuery({
        queryKey: [currency],
        queryFn: () => handleFetchAllBanks(currency),
        staleTime: Infinity,
    });
    const kenyaCurrency = currency === "KES";
    const { isLoading: verifyingAccount } = useQuery({
        queryKey: ["accountNumber", accountNumber, selectedBank?.value],
        enabled: kenyaCurrency
            ? false
            : typeof accountNumber === "string" &&
              accountNumber.length >= 10 &&
              !!selectedBank?.value,
        queryFn: () => handleVerifyAccount(accountNumber, selectedBank?.value),
        onSettled: (data) => {
            if (!data?.data?.error) {
                setAccountName(data?.data?.accountName);
            }
        },
    });

    const bankListOptions = bankList?.data?.map((option) => ({
        label: option?.name,
        value: option?.code,
    }));

    const isDisabled = !accountName || !accountNumber || !selectedBank;

    const handleClose = () => {
        setSelectedBank(null);
        setAccountName("");
        setAccountNumber("");
        setSelectedSupplier(null);
        onClose();
    };

    return (
        <div>
            <Modal
                show={show}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="border-0 z-[9999]"
            >
                <Modal.Body
                    style={{
                        borderRadius: "16px",
                        padding: "0px",
                        border: "none",
                    }}
                    className="bg-white rounded-md"
                >
                    <div className="relative w-full gap-4 px-4 pt-4">
                        <div className="flex flex-col items-center justify-center text-center">
                            <FeaturedIcon2 />
                            <h5 className="text-xl font-semibold text-gray-90">
                                Add payment information
                            </h5>

                            <span
                                className="absolute cursor-pointer material-icons top-4 right-4"
                                style={{ color: "#667085" }}
                                onClick={handleClose}
                            >
                                close
                            </span>
                        </div>

                        <p className="text-base font-normal text-center text-gray-50">
                            Please add{" "}
                            <span className="capitalize">
                                [{selectedSupplier?.name?.toUpperCase()}]
                            </span>{" "}
                            payment details to continue.
                        </p>
                    </div>
                    <div className="flex flex-col w-full gap-3 px-4 py-4">
                        <Select
                            options={bankListOptions}
                            className="react-select-container bg-[#EFF0FA]"
                            classNamePrefix="react-select"
                            placeholder={verifyingAccount ? "Loading..." : "Select a bank"}
                            onChange={(value) => setSelectedBank(value)}
                            value={selectedBank}
                            isClearable={true}
                        />

                        <Input
                            inputClassName="!bg-[#EFF0FA] shadow-none mt-1"
                            type="text"
                            name="accountNumber"
                            onChange={(value) => {
                                setAccountNumber(value);
                            }}
                            value={accountNumber}
                            placeholder="Account number"
                        />
                        <InputField
                            onChange={(value) => {
                                setAccountName(value);
                            }}
                            value={verifyingAccount ? "Loading..." : accountName}
                            showIcon={false}
                            disabled={kenyaCurrency ? false : true}
                            placeholder="Account name"
                            wrapperClassName="max-w-full h-[56px]"
                        />
                    </div>
                    <div
                        className="flex items-center justify-between px-4 py-3 gap-x-5"
                        style={{
                            borderTop: "1px solid #E7E9FB",
                        }}
                    >
                        <Button onClick={() => handleClose()} className="px-0" variant="ghost">
                            <ChevronLeft /> Back to suppliers
                        </Button>
                        <GenericBtn
                            disabled={isDisabled || isLoading}
                            onClick={onSubmit}
                            text="Save"
                        />
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default AddPoPaymentInfoModal;
